/**
 * Event Manager **API** application role names in Microsoft Entra (EM_B_*).
 * These are enforced on the backend when the SPA calls the API; they are not
 * the same as portal UI roles in the ID token (e.g. EM_F_Admin).
 * Used in help text and error hints only.
 */
export const ROLE_ADMIN_EXPORT_SETTINGS = "EM_B_Admin_Export_Settings";
export const ROLE_ADMIN_CHANGE_NUMBER_RANGES = "EM_B_Admin_Change_Number_Ranges";
export const ROLE_ADMIN_WORDING_GUARD_WRITE = "EM_B_Admin_Wording_Guard_Write";

/** Portal role that gates access to the Admin area in this SPA (ID token). */
export const ROLE_PORTAL_ADMIN = "EM_F_Admin";

/**
 * Event Manager API role required for admin translation backlog + bulk re-translate endpoints
 * (and other approve-level admin reports). Assign on the API app in Entra.
 */
export const ROLE_API_ADMIN_APPROVE = "EM_B_Admin_Approve";
